import { useAuth } from "@/context/auth/AuthContext";
import React from "react";
import { Navigate } from "react-router-dom";

interface PrivateRouteProps {
  outlet: React.ReactNode;
}

export const PrivateRouteWithInstance = ({ outlet }: PrivateRouteProps) => {
  const { checkToken, checkInstanceAndToken, boPreferencesReady } = useAuth();

  if (!checkToken()) {
    return <Navigate to="/login" />;
  }

  if (!checkInstanceAndToken()) {
    return <Navigate to="/instance" />;
  }

  // Wait for UserConfig hydrate so tables don't mount with defaults and
  // overwrite server-side column/view preferences on the next PUT.
  if (!boPreferencesReady) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-muted-foreground border-t-transparent" />
      </div>
    );
  }

  return outlet;
};
